var exports = {
  "F": "x0a7806d5--9c0605--link-container",
  "n": "x0a7806d5--9c0605--link",
};

module.exports = exports;
